import { useContext, useMemo } from 'react';

import UserPermissionsContext from '../UserPermissionsContext';

const useSearch = ({ options }) => {
  const { searchQuery } = useContext(UserPermissionsContext);

  const filteredOptions = useMemo(() => {
    return searchQuery
      ? options?.filter(({ name }) => {
          return name
            .toLocaleLowerCase()
            .includes(searchQuery.toLocaleLowerCase());
        })
      : options;
  }, [options, searchQuery]);

  return { searchQuery, filteredOptions };
};

export default useSearch;
